document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-kin-delivery-link]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const details = document.getElementById(link.hash.slice(1));
  if (!details || details.tagName !== 'DETAILS') return;
  event.preventDefault();
  const summary = details.querySelector('summary');
  if (!details.open) summary.click();
  summary.focus({preventScroll: true});
  requestAnimationFrame(() => details.scrollIntoView({block: 'start', behavior: 'auto'}));
});
